'use client';

import { Navigate, useParams } from 'react-router-dom';
import PoetClient from './PoetClient';
import { workshopByGroupId } from '@/data/workshopGroups';

export default function BPFWorkshopPoetPage() {
  const { groupId, poetName } = useParams();
  if (!groupId || !poetName) return <Navigate to="/Qiaodong/BPF/workshop" replace />;
  const groupData = workshopByGroupId[groupId];
  const decoded = decodeURIComponent(poetName);
  const poets = groupData.poets as Record<string, unknown>;
  const poet = poets[decoded];
  if (!poet) return <Navigate to={`/Qiaodong/BPF/workshop/${groupId}`} replace />;
  return <PoetClient poet={poet} groupId={groupId} />;
}
